import log from 'salvo-lite/log'

class Lookbook {
    constructor (theme, elem) {
        log.debug(this.constructor.name, 'Constructing', this)
        this._elem = elem
        this._lookbookMain = this._elem.querySelector('[data-lookbook-main]')
        this._lookbookMainItems = this._lookbookMain.querySelectorAll('[data-lookbook-main-item]')
        this._lookbookSub = this._elem.querySelector('[data-lookbook-sub]')
        this._lookbookSubItems = this._lookbookSub.querySelectorAll('[data-lookbook-sub-item]')
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')

        for (let [index, lookbookSubItem] of this._lookbookSubItems.entries()) {
            lookbookSubItem.addEventListener('click', (e) => {
                e.preventDefault()
                let mainElem = this._lookbookMainItems[index]
                log.debug(this.constructor.name, 'Offset of item', mainElem.offsetLeft)
                this._lookbookMain.scroll({
                    top: 0,
                    left: mainElem.offsetLeft,
                    behavior: 'smooth'
                })
            })
        }

        this._lookbookMain.addEventListener('scroll', (e) => {
            log.debug(this.constructor.name, 'Scroll of elem', this._lookbookMain.scrollLeft)
            let scrollLeft = this._lookbookMain.scrollLeft

            for (let [index, lookbookItem] of this._lookbookMainItems.entries()) {
                if (scrollLeft >= lookbookItem.offsetLeft) {
                    if ((index + 1) === this._lookbookMainItems.length || (scrollLeft < this._lookbookMainItems[index + 1].offsetLeft)) {
                        for (let lookbookSubItem of this._lookbookSubItems) {
                            lookbookSubItem.classList.remove('active')
                        }
                        let subItem = this._lookbookSubItems[index]
                        subItem.classList.add('active')
                        this._lookbookSub.scroll({
                            top: 0,
                            left: subItem.offsetLeft,
                            behavior: 'smooth'
                        })
                    }
                }
            }
        })

        log.debug(this.constructor.name, 'Initiated')
    }
}

export default Lookbook



// WEBPACK FOOTER //
// ./src/scripts/components/Lookbook.js